module.exports = __webpack_public_path__ + "img/beak_clewsy11.cdf0d0e.png";